import { DateTime } from 'luxon';
import React from 'react';
import { BrowserView } from 'react-device-detect';
import { Link } from 'react-router-dom';

import Emprestimo from 'Interface/EmprestimosUniforme';

interface Props {
  dados: Emprestimo;
}

const Lista = ({ dados }: Props): React.ReactElement => {
  return (
    <div className="d-flex border-bottom align-items-center justify-content-between py-2 px-3">
      <div className="fs-4">
        <Link
          to={`/emprestimos-uniforme/assinar/${dados.id}`}
          className="text-decoration-none"
        >
          {dados.uniforme?.nome}
        </Link>
        <small className="text-muted fs-6 d-block">
          Tamanho: {dados.uniforme?.tamanho}
        </small>
      </div>
      <BrowserView className="d-flex align-items-center">
        <div className="ms-5 fs-5 text-end">
          <div className="fs-4">
            {dados.quantidade}
            <small className="text-muted fs-6 d-block">Quantidade</small>
          </div>
        </div>
        <div className="ms-5 fs-5 text-end">
          <div className="fs-4">
            {dados.criado.data().toLocaleString(DateTime.DATETIME_SHORT)}
            <small className="text-muted fs-6 d-block">
              Data do emprestimo
            </small>
          </div>
        </div>
      </BrowserView>
    </div>
  );
};

export default Lista;
